import React, { useEffect, useState } from "react";
import "./styles.css";
import { ButtonCheckout } from "../buttonCheckout/ButtonCheckout";
import { useOrder } from "../../hooks/useOrder";
import { useDiscount } from "../../hooks/useDiscount";

const ModalSelectInstallment: React.FC<{
  open: boolean;
  onClose: () => void;
  payments: any;
  paymentSelected: any;
  total: any;
  config: any;
  setInstallment: any;
  onNext: any;
  setCodePlanSelected: any;
}> = ({
  open,
  onClose,
  payments,
  paymentSelected,
  total,
  config,
  setInstallment,
  onNext,
  setCodePlanSelected,
}) => {
    const [installmentSelected, setInstallmentSelected] = useState<number | null>(
      null
    );
    const orderContext = useOrder();

    useEffect(() => {
      if (paymentSelected && total && paymentSelected.paymentPlans) {
        const parcelasValidas = paymentSelected.paymentPlans.filter(
          (plan: any) => {
            const valorParcela = total / plan.installment;
            return valorParcela >= paymentSelected.minimumValueInstallment;
          }
        );

        if (parcelasValidas.length <= 1) {
          orderContext.setInstallment(1);
          setInstallmentSelected(1);
          orderContext.setInstallmentValue(total);
          setCodePlanSelected(paymentSelected.paymentPlans[0].codePlan);
        }
      }
    }, [paymentSelected, total]);

    useEffect(() => {
      if (!installmentSelected) return;
      onNext();
    }, [installmentSelected])

    const handleInstallmentSelect = (plan: any) => {
      const totalValue = total || 0;
      const installmentValue = totalValue / plan.installment;
      setInstallmentSelected(plan.installment);
      orderContext.setInstallment(plan.installment);
      orderContext.setInstallmentValue(installmentValue);
      setCodePlanSelected(plan.codePlan);
    };

    const trunCat = (num: number, decimals: number) => {
      const formatter = Math.pow(10, decimals);
      const res = Math.floor(num * formatter) / formatter
      return res;
    }

    return (
      <div className={`modal-overlay ${open ? "open" : ""}`} onClick={onClose}>
        <div
          className={`modal-content ${open ? "slide-up" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-section">
            <div className="modal-header">
              <h3>Selecione a parcela</h3>
            </div>
            <button className="close-btn" onClick={onClose}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8L16 16"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M16 8L8 16"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <div className="installments-list">
              <div className="payment-method">
                {paymentSelected?.typePay === "Others" ? (
                  <div className="payment-method-others">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z"
                        fill="#1B1B1B"
                      />
                      <path
                        d="M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z"
                        fill="#1B1B1B"
                      />
                    </svg>
                  </div>
                ) : paymentSelected?.brandItem?.img ? (
                  <img
                    src={paymentSelected?.brandItem?.img}
                    alt={paymentSelected?.brandItem?.operator}
                    className="payment-icon"
                  />
                ) : null}
                <span>{paymentSelected?.brand}</span>
              </div>
              {paymentSelected &&
                paymentSelected.paymentPlans &&
                paymentSelected.paymentPlans.length > 0 ? (
                [...paymentSelected.paymentPlans]
                  .sort((a: any, b: any) => a.installment - b.installment)
                  .map((plan: any, idx: number) => {
                    const totalValue = total || 0;
                    const installmentValue = totalValue / plan.installment;
                    const truncatedInstallment = trunCat(installmentValue, 2);
                    const formattedInstallment = truncatedInstallment.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    });

                    if (
                      idx > 0 &&
                      installmentValue < parseFloat(paymentSelected.minimumValueInstallment)
                    )
                      return null;

                    return (
                      <div
                        key={plan.id || idx}
                        className="installment-option"
                        onClick={() => handleInstallmentSelect(plan)}
                      >
                        <input
                          type="radio"
                          name="installment"
                          id={`installment-${plan.installment}`}
                          checked={installmentSelected === plan.installment}
                          onChange={() => { }}
                        />
                        <label htmlFor={`installment-${plan.installment}`}>
                          {plan.installment}x {formattedInstallment}
                        </label>
                      </div>
                    );
                  })
              ) : (
                <p>Nenhuma opção de parcela disponível.</p>
              )}
            </div>
          </div>
          <div className="modal-actions">
            <button className="clear-btn" onClick={onClose}>
              Voltar
            </button>
            <button
              className="filter-btn"
              onClick={onNext}
              style={{
                backgroundColor: config?.webappcolor?.webappbutton || "#EAEAEA",
                color: config?.webappcolor?.fontbutton || "#636363",
                cursor: !installmentSelected ? "not-allowed" : "pointer",
                opacity: !installmentSelected ? 0.6 : 1,
              }}
              disabled={!installmentSelected}
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    );
  };

export default ModalSelectInstallment;
